module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AQz6zm/tc-custom/9781647502621.jpg?1719603367462",
      "alt": "This image is the cover for the book You, Naughty Mum!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("You, Naughty Mum!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A truly varied and innovative collection, branded Lucio Angelini. Next to apparently traditional fairy tales, in which the author had fun practicing the so-called “reversal of the reader's expectations” ("), _c('em', [_vm._v("You, Naughty Mum!")]), _vm._v(", for example, very enjoyable even by an adult audience), we find ironic reinterpretations of famous fairy tales ("), _c('em', [_vm._v("Whitedwarf and the Seven Snows")]), _vm._v(") or fairy tales in which the real and the surreal intertwine in a particularly liberating mix (in "), _c('em', [_vm._v("Inside Oronzo’s ")]), _c('em', [_vm._v("B")]), _c('em', [_vm._v("ig ")]), _c('em', [_vm._v("H")]), _c('em', [_vm._v("ead,")]), _vm._v(" the child Oronzo takes revenge in a totally unpredictable way for the pedagogical sadism of his teacher). Particularly interesting are some “meta-tales”, in which the author does not hesitate to highlight typical “ingredients” or “clichés” or “construction mechanisms” of traditional fairy tales.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lucio Angelini\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "14px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "14px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("As he wrote in one of his Italian novels ("), _c('em', [_vm._v("Il fantasma di Andersen")]), _vm._v("): “The most striking episode of my childhood was when the ghost of a tall, slouching boy with a big nose appeared to me: Hans Christian Andersen.” Born in Fano, Italy, but living in Venice, Lucio Angelini is a translator of novels and essays for major Italian publishers (Einaudi, Mondadori, Frassinelli, Fazi, and others) and a writer. He translated into Italian Charlotte Brontë, Virginia Woolf, Edgar Allan Poe, Gandhi, Einstein, Tobias Wolff, Lewis Carroll and others, including Patricia Cornwell’s "), _c('em', [_vm._v("Body of Evidence")]), _vm._v(" ("), _c('em', [_vm._v("Oggetti di reato")]), _vm._v(", Mondadori). He also translated into Italian three novels by Hans Christian Andersen: "), _c('em', [_vm._v("Only a Fiddler, O.T. – A Danish Novel, The Two Baronesses")]), _vm._v(". As a writer, he has written mainly short stories for children and young adults. His collection "), _c('em', [_vm._v("You, Naughty Mum! (And Other Tales)(Quella bruttacattiva della mamma!, ")]), _vm._v("Emme Edizioni"), _c('em', [_vm._v(")")]), _vm._v(" was translated into French with the title "), _c('em', [_vm._v("Méchante Maman")]), _vm._v(" (Flammarion). In 2013, he published in Italy "), _c('em', [_vm._v("The Chinese Gondolier (Il gondoliere cinese)")]), _vm._v(", an environmentalist noir for adults, in support of the campaign for the expulsion of giant cruise ships from the Venetian lagoon.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0